import { Component, Inject, OnInit } from '@angular/core';
import { ListService } from '@app/common/services/list.service';

import { AuthService } from '@app/common/services/auth.service';
import { ListModel } from '@app/common/models/list.model';
import {DocumentModel} from "@app/common/models/document.model";
import { TabModel } from '@app/common/models/tab.model';
import { StateService } from '@uirouter/angular';
import { NoteModel } from '@app/common/models/note.model';
import { HelpService } from '@app/common/services/help.service';

@Component({
  selector: 'documents-to-classify',
  templateUrl: './documents-to-classify.component.html',
})
export class DocumentsToClassifyComponent implements OnInit {
  documentList: ListModel<DocumentModel>;
  historyList: ListModel<NoteModel>;
  tabs: TabModel[];
  public tab: string;
  helpIds = HelpService.HELP_IDS;
  private getTabs(): TabModel[] {
    return [
      {
        name: 'Dokumenty EPD k zařazení',
        id: 'documents',
        href: 'symap.project.document-classify',
        urlParams: {tab: 'documents'},
      },
      {
        name: 'Historie',
        id: 'history',
        href: 'symap.project.document-classify',
        urlParams: {tab: 'history'},
      },
    ];
  }
  constructor(
    public authService: AuthService,
    public listService: ListService,
    private stateService: StateService,
  ) {
    this.isActiveTab = this.isActiveTab.bind(this);
  }

  async ngOnInit() {
    this.loadDocuments();
    this.tabs = this.getTabs();
    this.tab = (this.stateService.params.tab ? this.stateService.params.tab : 'documents');
  }

  public loadDocuments() {
    this.loadHistory();
    this.documentList = this.listService.createList(
      'documents',
      {
        limit: null,
        filters: { classified: false, cancelled: false, loadCollections: ['components'] }}
    );

    this.listService.fetchResult(this.documentList).then((d) => {
      this.onUpdateDocumentsList();
    });
  }

  public loadHistory() {
    this.historyList = this.listService.createList(
      'notes',
      {
        filters: { documentClassification : true, systemType: true },
        sortOrder: { sortBy: 'timestamp', direction: 'desc' }
      }
    );
    this.listService.fetchResult(this.historyList).then(() => {
      this.onUpdateHistoryList();
    });
  }

  canEdit() {
    return this.authService.hasPermission('admin');
  }

  isActiveTab(id: string) {
    return id === this.tab;
  }

  uiOnParamsChanged(changedParams) {
    this.tab = changedParams.tab;
  }

  onUpdateDocumentsList() {
    const documentsTab = this.tabs.find((tab) => tab.id === 'documents');
    documentsTab.name = `Dokumenty EPD k zařazení (${this.documentList.list.filter(a => !a.cancelled).length})`;
  }

  onUpdateHistoryList() {
    const historyTab = this.tabs.find((tab) => tab.id === 'history');
    historyTab.name = `Historie (${this.historyList.itemCount})`;
  }
}
